// extracted by mini-css-extract-plugin
export default {"container":"Preview_container__7vlCu","inner":"Preview_inner__1EsDd","newpage":"Preview_newpage__HIey4"};